import { Controller } from '@stimulus/core'

export default class SuggestionController extends Controller {
  static targets = ["title", "description"]
  static values = {
    target: String
  }

  selectTitle(event: Event) {
    const radio = event.currentTarget as HTMLInputElement
    const value = radio.value

    const dutchTitleField = document.querySelector<HTMLInputElement>('input[id*="permanent_offer_title_nl"]')
    if (dutchTitleField && value) {
      dutchTitleField.value = value
  
      const customEvent = new CustomEvent('title:selected', {
        bubbles: true,
        detail: { value }
      })
      this.element.dispatchEvent(customEvent)

      // Zorgt ervoor dat de max character counter van de titel geüpdatet wordt.
      dutchTitleField.dispatchEvent(new Event('input', { bubbles: true }))
      dutchTitleField.dispatchEvent(new Event('change', { bubbles: true }))
    }
  }

  handleDescriptionAppend(event: Event) {
    this.handleDescription(event, true)
  }

  handleDescription(event: Event, append: boolean = false) {
    const button = event.currentTarget as HTMLButtonElement
    const value = button.dataset.suggestionValue
    if (!value) return

    const dutchDescField = document.querySelector<HTMLTextAreaElement>('textarea[id*="permanent_offer_description_nl"]')
    if (!dutchDescField) return

    if (append) {
      const line = this.generateFullLine(dutchDescField, '-')
      dutchDescField.value += (dutchDescField.value ? '\n\n' : '') + line + '\n\n' + value
    } else {
      dutchDescField.value = value
    }

    const allOptions = document.querySelectorAll('.description-suggestions .suggestion-option')
    allOptions.forEach(option => option.classList.remove('selected'))

    const selectedOption = button.closest('.suggestion-option')
    if (selectedOption) selectedOption.classList.add('selected')
  }

  generateFullLine(textarea: HTMLTextAreaElement, char = '-', offset = 4) {
    const style = window.getComputedStyle(textarea)
    const font = style.fontFamily
    const fontSize = style.fontSize

    const canvas = document.createElement('canvas')
    const ctx = canvas.getContext('2d')
    if (!ctx) return char.repeat(50)

    ctx.font = `${fontSize} ${font}`

    const charWidth = ctx.measureText(char).width
    const textareaWidth = textarea.clientWidth

    const charsPerLine = Math.floor(textareaWidth / charWidth) - offset

    return char.repeat(charsPerLine > 0 ? charsPerLine : 1)
  }
} 